var zIndex = {"z-1":"100","z-2":"400","z-3":"510","z-4":"512","z-5":"513","z-6":"514","z-7":"515","z-8":"516","z-9":"517","z-10":"518","z-11":"519","z-12":"520"};

export { zIndex as default };
